export default __webpack_public_path__ + "static/media/i140hp.6cc691ec.webp";